import { Component, Input, OnInit, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from "@angular/common";
import { UUID } from 'angular2-uuid';
import { Router } from '@angular/router';

import { EventsService, Event } from "../../services/events/events.service";
import { GoogleService } from "../../services/google/google.service";

declare const google: any;

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit, AfterViewInit {

    @Input('events') events: Event[];
    @Input('params') params: any;

    map: any;
    bounds: any;
    map_dom_id: string = UUID.UUID();

    constructor(private router: Router, private google_service: GoogleService, private events_service: EventsService, @Inject(PLATFORM_ID) private platform_id: Object) {

        const $_ = this;
    }

    ngOnInit() {

        const $_ = this;

        if (isPlatformBrowser($_.platform_id)) {

            $_.events_service.item_changed$.subscribe(_event => {

                $_.events.find(event => {

                    var result = false;

                    if (_event) {

                        var result = event.id === _event.id;

                        if (result) {

                            if (event.marker_data && event.marker_data[$_.map_dom_id]) {

                                event.marker_data[$_.map_dom_id].update_on_map();
                            }
                            
                            $_.update_bounds();
                        }
                    }

                    return result;
                })
            })
        }
    }

    ngAfterViewInit() {

        const $_ = this;

        if (isPlatformBrowser($_.platform_id)) {

            $_.google_service.run_map_function(() => {

                $_.map = new google.maps.Map(document.getElementById($_.map_dom_id), {

                    center: new google.maps.LatLng($_.params.lat ? $_.params.lat : 0, $_.params.lng ? $_.params.lng : 0),
                    zoom: $_.params.zoom ? $_.params.zoom : 16,
                    gestureHandling: 'greedy'
                });

                // set up the event update functions
                $_.events.forEach((event: Event) => {

                    (function (event) {

                        event.marker_data = event.marker_data || {};

                        event.marker_data[$_.map_dom_id] = {

                            update_on_map: function () {

                                var marker_data = event.marker_data[$_.map_dom_id];

                                marker_data.event_position = new google.maps.LatLng(event.lat, event.lng);

                                if (!marker_data.marker) {

                                    marker_data.marker = new google.maps.Marker({

                                        position: marker_data.event_position
                                    });

                                    marker_data.html_div = document.createElement('div');
                                    marker_data.event_info_window = new google.maps.InfoWindow();

                                    google.maps.event.addListener(marker_data.marker, "click", (marker) => {

                                        marker_data.html_div.onclick = () => {

                                            $_.router.navigate(['/agency/' + event.parent_agency_id]);
                                        };
                                        marker_data.event_info_window.setContent(marker_data.html_div);
                                        marker_data.event_info_window.open($_.map);
                                    });

                                    marker_data.marker.setMap($_.map);

                                } else {

                                    marker_data.marker.setPosition(marker_data.event_position);
                                }

                                marker_data.event_info_window.setPosition(marker_data.event_position);
                                marker_data.html_div.innerHTML = `
                                <h6 class="cursor-pointer" style="color: blue; text-decoration: underline;"><a>${event.agencies}</a></h6>
                                </h6>
                                Street
                                <span style="font-weight: bold;">${event.street}</span>
                                <br>
                                Cross Streets
                                <span style="font-weight: bold;">${event.cross_streets}</span>
                                <br>
                                Type
                                <span style="font-weight: bold;">${event.type}</span>`;
                            }
                        }

                    })(event);

                    event.marker_data[$_.map_dom_id].update_on_map();
                })

                $_.update_bounds();
            });
        }
    }

    private update_bounds() {

        const $_ = this;

        if ($_.params.fit_bounds) {

            var bounds = new google.maps.LatLngBounds();

            $_.events.forEach((event: Event) => {

                if (event.lat && event.lng) {

                    bounds.extend(new google.maps.LatLng(event.lat, event.lng));
                }
            });

            if ($_.events.length > 1) {

                $_.map.fitBounds(bounds);
            }
            else if ($_.events.length === 1) {

                $_.map.setCenter(new google.maps.LatLng($_.events[0].lat, $_.events[0].lng));
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/map/map.component.ts